jQuery(document).ready(function ($) {
  $('.mb_colleagues-carousel .carousel-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true, // Show arrows by default
    prevArrow: "<button type='button' class='slick-arrow slick-arrow--prev'><i class='icon icon-chevron-left' aria-hidden='true'></i></button>",
    nextArrow: "<button type='button' class='slick-arrow slick-arrow--next'><i class='icon icon-chevron-right' aria-hidden='true'></i></button>",
    dots: true,
    appendDots: $('.carousel-dots'),
    infinite: true,
    fade: true,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 5000, // 5 seconds per slide
    pauseOnHover: true, // Pause on hover
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false // Hide arrows below 768px
        }
      }
    ]
  });
});
